import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

window.bootstrap = Object.assign(window.bootstrap || {}, { Collapse, Dropdown, Modal, Offcanvas });
